document.addEventListener("DOMContentLoaded", function() {
var slider = document.getElementById("pgvgSlider");
var output = document.getElementById("sliderValue");
var flavorOutput = document.getElementById("flavorDescription");
var benefitsOutput = document.getElementById("benefits");

// Set initial value for the CSS variable
slider.style.setProperty('--value', '50%');

slider.oninput = function() {
  var pgValue = this.value;
  
  // Snap to closest trigger point
  if (pgValue >= 60) {
    pgValue = 70;
  } else if (pgValue >= 40) {
    pgValue = 50;
  } else if (pgValue >= 25) {
    pgValue = 30;
  } else {
    pgValue = 20;
  }
  
  var vgValue = 100 - pgValue;
  var ratio = pgValue + "% PG / " + vgValue + "% VG";
  
  // Update the CSS variable for the active part of the slider
  slider.style.setProperty('--value', pgValue + '%');
  slider.value = pgValue; // Update the slider position
  
  // Update ratio, throat hit, and benefits based on PG/VG ratio
  updateSliderText(pgValue, ratio);
}

function updateSliderText(pgValue, ratio) {
  output.innerHTML = "<strong>Current Ratio:</strong> " + ratio;
  if (pgValue == 70) {
    flavorOutput.innerHTML = "<strong>Throat Hit:</strong> High";
    benefitsOutput.innerHTML = '<div class="benefits-item">🎯 <strong>Strong Flavor:</strong> Mimics the intense sensation of smoking, making the transition easier.</div>';
  } else if (pgValue == 50) {
    flavorOutput.innerHTML = "<strong>Throat Hit:</strong> Medium";
    benefitsOutput.innerHTML = '<div class="benefits-item">🔄 <strong>Balanced Flavor:</strong> Offers a moderate throat hit and flavor, suitable for those reducing nicotine intake.</div>';
  } else if (pgValue == 30) {
    flavorOutput.innerHTML = "<strong>Throat Hit:</strong> Low";
    benefitsOutput.innerHTML = '<div class="benefits-item">🌿 <strong>Mild Flavor:</strong> Ideal for those who have successfully reduced nicotine levels and enjoy smoother vaping.</div>';
  } else if (pgValue == 20) {
    flavorOutput.innerHTML = "<strong>Throat Hit:</strong> Very Low";
    benefitsOutput.innerHTML = '<div class="benefits-item">🌿 <strong>Very Mild Flavor:</strong> Ideal for those who enjoy smoother vaping with minimal throat hit.</div>';
  }
}
});